// Raw Exam Data - start
export const FETCH_RAW_EXAM_DATA_REQUEST = 'FETCH_RAW_EXAM_DATA_REQUEST';
export const FETCH_RAW_EXAM_DATA_SUCCESS = 'FETCH_RAW_EXAM_DATA_SUCCESS';
export const FETCH_RAW_EXAM_DATA_FAILURE = 'FETCH_RAW_EXAM_DATA_FAILURE';

export const REFRESH_RAW_EXAM_DATA_REQUEST = 'REFRESH_RAW_EXAM_DATA_REQUEST';
export const REFRESH_RAW_EXAM_DATA_SUCCESS = 'REFRESH_RAW_EXAM_DATA_SUCCESS';   
export const REFRESH_RAW_EXAM_DATA_FAILURE = 'REFRESH_RAW_EXAM_DATA_FAILURE';
// Raw Exam Data - end